<script setup lang="ts">
import { ref, onMounted } from "vue";
import "element-plus/theme-chalk/dark/css-vars.css";

interface BannerConfig {
  type: "img" | "video";
  bgurl: string;
  position?: string;
  fit?: string;
  bannerTitle?: string;
  bannerText?: string | null;
}

const props = defineProps<{
  banner: BannerConfig;
}>();

const loading = ref(true);
const bannerRef = ref<HTMLImageElement | HTMLVideoElement | null>(null);

onMounted(() => {
  if (bannerRef.value) {
    if (props.banner.type === "img") {
      const img = bannerRef.value as HTMLImageElement;
      if (img.complete) {
        loading.value = false;
      } else {
        img.onload = () => {
          loading.value = false;
        };
      }
    } else if (props.banner.type === "video") {
      const video = bannerRef.value as HTMLVideoElement;
      if (video.readyState >= 3) {
        // HAVE_FUTURE_DATA
        loading.value = false;
      } else {
        video.oncanplay = () => {
          loading.value = false;
        };
      }
    }
  }
});
</script>

<template>
  <el-skeleton style="width: 100%; height: 600px;"
               :loading="loading"
               animated
               :throttle="500">
    <template #template>
      <el-skeleton-item variant="image"
                        style="width: 100%; height: 600px" />
    </template>

    <template #default>
      <div class="trm-banner-container">
        <template v-if="banner.type === 'img'">
          <img ref="bannerRef"
               class="trm-banner-cover"
               :src="banner.bgurl"
               :style="{
                 objectPosition: banner.position || 'top',
                 objectFit: banner.fit || 'cover'
               }"
               alt="banner" />
        </template>
        <template v-else-if="banner.type === 'video'">
          <video ref="bannerRef"
                 class="trm-banner-cover"
                 autoplay
                 loop
                 muted
                 playsinline
                 webkit-playinginline>
            <source :src="banner.bgurl"
                    type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"' />
            Your browser does not support HTML5 video.
          </video>
        </template>
      </div>
    </template>
  </el-skeleton>
</template>